import { Image } from "antd";
import { useImageLoader } from "../../components/customHook/ImageLoader";

const ImagePreview = ({ file }) => {
  const { imageUrl } = useImageLoader(file?.resourceId);

  return (
    <Image
      width={200}
      src={imageUrl}
      // className={`image-item ${comment?.attachFiles?.length === 1 ? "single-image" : ""}`}
    />
  );
};
export default ImagePreview;
